import { useAtom } from 'jotai';
import { currentSlideAtom } from '../states/planner';
import arrowLeft from '../assets/arrow_left.svg';
import arrowRight from '../assets/arrow_right.svg';

export const PrevAndNextButtons = ({ totalSlides }: { totalSlides: number }) => {
  const [currentSlide, setCurrentSlide] = useAtom(currentSlideAtom);

  const onlyOneSlideClass = totalSlides === 1 ? 'oneslidebutton' : '';

  return (
    <>
      <div
        className={`-bottom-15 absolute left-[calc(50%-100px)] flex h-12 -translate-x-1/2 items-center justify-center ${onlyOneSlideClass}`}
      >
        <button onClick={() => setCurrentSlide(prev => Math.max(prev - 1, 0))} disabled={currentSlide === 0}>
          <img
            src={arrowLeft}
            alt="arrow left"
            className={`h-8 w-8 ${currentSlide === 0 ? 'opacity-50' : 'hover:h-9 hover:w-9'}`}
          />
        </button>
      </div>

      <div
        className={`-bottom-15 absolute left-[calc(50%+100px)] flex h-12 -translate-x-1/2 items-center justify-center ${onlyOneSlideClass}`}
      >
        <button
          onClick={() => setCurrentSlide(prev => Math.min(prev + 1, totalSlides - 1))}
          disabled={currentSlide === totalSlides - 1}
        >
          <img
            src={arrowRight}
            alt="arrow right"
            className={`h-8 w-8 ${currentSlide === totalSlides - 1 ? 'opacity-50' : 'hover:h-9 hover:w-9'}`}
          />
        </button>
      </div>
    </>
  );
};
